

































































































































































import CompanyUserRequired from "../CompanyRequired";
import {Component, Inject, Prop, Watch} from "vue-property-decorator";
import {
  ChargerPurchaseItem,
  companyroleid,
  DateTime,
  DeliveryAddress, OutOfStockShopItem,
  PurchaseItem,
  PurchaseOrder, TerminalBatteryPurchaseItem,
  TerminalLocation, NfcFrontTapPurchaseItem,
  TerminalPurchaseItem, TerminalSignPurchaseItem, UsbBCablePurchaseItem
} from "@/modules/models";
import rd from "@/modules/vRoutedefs";
import Api from "./Api";
import {numFormNOK} from "@/modules/utils";
import EllipsisScroller from "@/components/EllipsisScroller.vue";
import OrderItemsList from "./OrderItemsList.vue";
import {ignoreRedundantNavErr} from "@/router";
import {TerminalWarrantyYears} from "@/modules/constants";
import OutOfStockDialog from "@/components/shop/OutOfStockDialog.vue";

const noLocation = new TerminalLocation(
    0, "Uten anlegg innstilt", 0, false, null, null,
    null, null, false, false, false,
    false, 0
);

interface StockItem {
  id: number;
  name: string;
  outOfStock: boolean;
}

@Component({
    components: {
        OutOfStockDialog,
        "at-ellipsis-scroller": EllipsisScroller,
        "at-items-list": OrderItemsList,
    }
})
export default class NewOrderPage extends CompanyUserRequired {
    @Inject()
    api!: Api;

    @Prop({default: 0})
    chosenLocationId!: number;

    readonly terminalWarrantyYears = TerminalWarrantyYears;

    locations: TerminalLocation[] = [noLocation];

    order: PurchaseOrder | null = null;

    chosenLocation: TerminalLocation = noLocation;

    outOfStockItem: OutOfStockShopItem | null = null;

    batteries: StockItem[] = [
      {
        id: 1,
        name: "FX 100",
        outOfStock: true,
      },
      {
        id: 2,
        name: "FX 105",
        outOfStock: false,
      }
    ];
    chosenBattery: StockItem|null = null;

    setOutOfStockItem(name: string, action: string) {
      this.outOfStockItem = { name, action }
    }

    get priceInfoTo() {
        return rd.docs.priceinfo.path;
    }

    nokFormatted(num: number) {
        return numFormNOK(num);
    }

    get formattedTerminalPrice() {
        return numFormNOK(TerminalPurchaseItem.regularPrice);
    }

    addTerminalPurchase() {
      this.addPurchase(new TerminalPurchaseItem(1, this.chosenLocation.id, TerminalPurchaseItem.regularPrice, this.chosenLocation.description));
    }

    get formattedSignPrice() {
        return this.nokFormatted(TerminalSignPurchaseItem.regularPrice);
    }

    addSignPurchase() {
      this.addPurchase(new TerminalSignPurchaseItem(1, TerminalSignPurchaseItem.regularPrice));
    }

    get formattedBatteryPrice() {
      return numFormNOK(TerminalBatteryPurchaseItem.regularPrice);
    }

    addNfcFrontTapPurchase() {
      this.addPurchase(new NfcFrontTapPurchaseItem(1, NfcFrontTapPurchaseItem.regularPrice))
    }

  get formattedNfcFrontTapPrice() {
    return numFormNOK(NfcFrontTapPurchaseItem.regularPrice);
  }

    addBatteryPurchase() {
      if (!this.chosenBattery) {
        return;
      }

      if (this.chosenBattery.outOfStock) {
        return this.setOutOfStockItem(`Batteri (${this.chosenBattery.name})`, 'Det er derfor nødvendig å bestille en ny kortleser.')
      }

      this.addPurchase(new TerminalBatteryPurchaseItem(1, TerminalBatteryPurchaseItem.regularPrice));
    }

    addPurchase(item: PurchaseItem) {
      if(this.order) {
        this.order.items = [...this.order.items, item];
      } else {
        throw new Error("order is null");
      }
    }

    get formattedChargerPrice() {
      return numFormNOK(ChargerPurchaseItem.regularPrice);
    }

    addChargerPurchase() {
      this.addPurchase(new ChargerPurchaseItem(1, ChargerPurchaseItem.regularPrice));
    }

    get formattedCablePrice() {
      return numFormNOK(UsbBCablePurchaseItem.regularPrice);
    }

    addCablePurchase() {
      this.addPurchase(new UsbBCablePurchaseItem(1, UsbBCablePurchaseItem.regularPrice));
    }

  addItemAmount(item: PurchaseItem) {
        item.amount = item.amount + 1;
    }
    subItemAmount(item: PurchaseItem) {
        if(item.amount > 1) {
            item.amount = item.amount - 1;
        } else if(this.order) {
            this.order.items = this.order.items.filter(it => it !== item);
        }
    }

    loadingLocations = false;
    async loadLocations() {
        try {
            this.loadingLocations = true;
            this.locations = [noLocation].concat((await this.api.fetchLocations(this.company.orgNum)).map(tlws => tlws.termloc));
            if(this.chosenLocationId > 0) {
                this.chosenLocation = this.locations.find(tl => tl.id == this.chosenLocationId) || this.chosenLocation;
            }
        } finally {
            this.loadingLocations = false;
        }
    }

    saving = false;
    async saveOrder() {
        if(this.order) {
            try {
                this.saving = true;
                const id = await this.api.savePurchaseOrder(this.order);
                // Go to OrderPage displaying order for further edits before confirmation
                await ignoreRedundantNavErr(this.$router.push({name: rd.shop.order.name, params: {id: id.toString()}, query: {"chosen-location-id": this.chosenLocationId.toString()}}));
            } finally {
                this.saving = false;
            }
        }
    }

    // List of already registered orders on company (up to 50)
    orderlist: PurchaseOrder[] = [];
    async loadOrderlist() {
        try {
            const ol = await this.api.listPurchaseOrders(this.company.orgNum);
            this.orderlist = ol;
        } catch (e) {
            this.emitError(e);
        }
    }
    get orderCount() {
        return this.orderlist.length;
    }
    get ordersPageTo() {
        return rd.shop.orders.path;
    }

    @Watch("$route", {immediate: true})
    onRouteChanged() {
        this.loadLocations();
        this.loadOrderlist();
        this.order = new PurchaseOrder(0, this.company.orgNum, this.user.person.guid, this.user.person.name, DateTime.now(), DeliveryAddress.newEmpty(), []);
    }

    created() {
        this.requireCompanyRoles([companyroleid.admin]);
    }
}
